import Region from "../../../Components/Region";

import ImageUploader from "../../../Components/ImageUploader";
import Keywords from "../../../Components/Keywords";
import { Spinner } from "react-bootstrap";
const
  Edit = ({
    form,
    setForm,
    value,
    handler,
    user,
    saveChange,
    loading,
    publishHandler,
    error,
    validate,
  }) => {

    return (
      <>
        <div className="row mt-2">
          <div className="col-12">
            <div className="border rounded py-4  mb-2 text-center ">
              {form?.category?.title}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <label className="form-label" htmlFor="first-name">
              عنوان
            </label>
            <input
              className="form-control"
              id="first-name"
              type="text"
              placeholder="عنوان آگهی خود را وارد نمایید"
              onChange={({ target: { value } }) => {
                handler("title", value);
              }}
              invalid
              value={value("title")}
              data-invalid={error.status && !validate("title")}
            />
            {error.status && !validate("title") && (
              <div className="invalid-feedback">عنوان اجباری است</div>
            )}

            <small className="fs-10">
              در عنوان بهتر است از ویژگی های متمایز نام برده شود
            </small>
          </div>
          <div className="col-12">
            <label className="form-label" htmlFor="first-name">
              توضیحات
            </label>

            <textarea
              className="form-control"
              id="first-name"
              type="text"
              rows={8}
              placeholder="توضیحات محصول را اینجا وارد نمایید"
              onChange={({ target: { value } }) => {
                handler("description", value);
              }}
              value={value("description")}
              data-invalid={error.status && !validate("description")}
            />
            {error.status && !validate("description") && (
              <div className="invalid-feedback">توضیحات اجباری است</div>
            )}
            <small className="fs-10">توضیحات راجع به محصول موردنظر</small>
          </div>
          <div className="col-12">
            <label className="form-label" htmlFor="first-name">
              نوع آگهی
            </label>
            <select
              className="form-control"
              id="email2"
              type="text"
              defaultValue={user?.user?.sex}
              onChange={({ target: { value } }) => {
                handler("model", value || false);
              }}
              value={value("model")}
              data-invalid={error.status && !validate("model")}
            >
              <option value={false}>انتخاب کنید</option>
              <option value={"sale"}>فروش</option>
              <option value={"request"}>درخواست</option>
              <option value={"rent"}>اجاره</option>
              <option value={"introduction"}>معرفی</option>
              <option value={"buy"}>خرید</option>
              <option value={"other"}>سایر</option>
            </select>
            {error.status && !validate("model") && (
              <div className="invalid-feedback">نوع آگهی اجباری است</div>
            )}
            <small className="fs-10">نوع آگهی خود را انتخاب نمایید</small>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <Region set={handler} value={value} />
          </div>
          <div className="col-12">
            <label className="form-label" htmlFor="first-name">
              آدرس
            </label>

            <input
              className="form-control"
              id="first-name"
              type="text"
              placeholder="آدرس آگهی را وارد نمایید"
              onChange={({ target: { value } }) => {
                handler("addres", value);
              }}
              value={value("addres")}
              data-invalid={error.status && !validate("addres")}
            />
            {error.status && !validate("addres") && (
              <div className="invalid-feedback">آدرس اجباری است</div>
            )}
            <small className="fs-10">آدرس مورد نظر را دقیق وارد کنید</small>
          </div>
        </div>
        <div className="row justify-content-center mt-3">
          <div className="col-12">
            <ImageUploader
              element={{
                key: "main_image",
                label: "عکس اصلی",
                subLabel: "عکس شاخص محصول خود را بارگذای نمایید",
              }}
              form={form}
              setForm={setForm}
              single={true}
            />
            {error.status && !validate("main_image") && (
              <div className="invalid-feedback">عکس اصلی اجباری است</div>
            )}
            <ImageUploader
              element={{
                key: "product_images",
                label: "عکس های محصول",
                subLabel: "می توانید چندین عکس را بارگذاری نمایید",
              }}
              form={form}
              setForm={setForm}
              single={false}
            />
            {error.status && !validate("product_images") && (
              <div className="invalid-feedback">عکس های محصول اجباری است</div>
            )}
            <Keywords
              form={form}
              setForm={setForm}
              options={{
                title: "کلمات کلیدی",
                key: "keywords",
              }}
            />
            {error.status && !validate("keywords") && (
              <div className="invalid-feedback"> کلمات کلیدی اجباری است</div>
            )}
          </div>
        </div>
        <div className="row justify-content-center mt-3">
          <div className="col-12 ">
            <div className="mb-2">
              <label>نوع شخص آگهی دهنده</label>
              <p className="fs-10 mb-1">مشخص کردن نوع شخص آگهی دهنده</p>
              <div className="d-flex align-items-center">
                <div className="check-box-wrapper">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDisabled"
                    id="flexRadioDisabled"
                    onClick={() => {
                      setForm({ ...form, type: "personal" });
                    }}
                    checked={form.type == "personal"}
                  />
                  <label className="form-check-label" htmlFor="flexRadioDisabled">
                    شخصی
                  </label>
                </div>
                <div className="check-box-wrapper">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDisabled"
                    id="flexRadioCheckedDisabled"
                    onClick={() => {
                      setForm({ ...form, type: "company" });
                    }}
                    checked={form.type == "company"}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioCheckedDisabled"
                  >
                    شرکتی
                  </label>
                </div>
              </div>
            </div>
            <div>
              {form.type === "personal" ? (
                <>
                  <div className="col-12">
                    <label className="form-label" htmlFor="first-name">
                      نام و نام خانوادگی
                    </label>

                    <input
                      className="form-control"
                      id="first-name"
                      type="text"
                      placeholder="نام و نام خانوادگی خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("fullname", value);
                      }}
                      defaultValue={user?.user?.fullname}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label" htmlFor="first-name">
                      موبایل
                    </label>

                    <input
                      className="form-control"
                      id="first-name"
                      type="number"
                      placeholder="موبایل خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("mobile", value);
                      }}
                      defaultValue={user?.user?.mobile}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label" htmlFor="first-name">
                      ایمیل
                    </label>

                    <input
                      className="form-control"
                      id="first-name"
                      type="email"
                      placeholder="ایمیل خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("email", value);
                      }}
                      defaultValue={user?.user?.email}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="col-12">
                    <label className="form-label" htmlFor="co_name">
                      نام شرکت
                    </label>

                    <input
                      className="form-control"
                      id="co_name"
                      type="text"
                      placeholder="نام شرکت خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("co_name", value);
                      }}
                      defaultValue={value("co_name", "contacts_data")}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label" htmlFor="co_tell">
                      تلفن شرکت
                    </label>

                    <input
                      className="form-control"
                      id="co_tell"
                      type="number"
                      placeholder="تلفن شرکت خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("co_tell", value);
                      }}
                      defaultValue={value("co_tell", "contacts_data")}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label" htmlFor="co_mobile">
                      موبایل شرکت
                    </label>

                    <input
                      className="form-control"
                      id="co_mobile"
                      type="number"
                      placeholder="موبایل شرکت خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("co_mobile", value);
                      }}
                      defaultValue={value("co_mobile", "contacts_data")}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label" htmlFor="co_addres">
                      آدرس شرکت
                    </label>

                    <input
                      className="form-control"
                      id="co_addres"
                      type="text"
                      placeholder="آدرس شرکت خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("co_addres", value);
                      }}
                      defaultValue={value("co_addres", "contacts_data")}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label" htmlFor="co_url">
                      آدرس وب سایت
                    </label>

                    <input
                      className="form-control"
                      id="co_url"
                      type="url"
                      placeholder="آدرس وب سایت شرکت خود را وارد کنید"
                      onChange={({ target: { value } }) => {
                        handler("co_url", value);
                      }}
                      defaultValue={value("co_url", "contacts_data")}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="col-12">
              <label className="form-label" htmlFor="price">
                قیمت آگهی (تومان)
              </label>
              <input
                className="form-control"
                id="price"
                type="number"
                placeholder=" قیمت را وارد کنید"
                onChange={({ target: { value } }) => {
                  handler("price", value);
                }}
                disabled={form.tava}
                defaultValue={value("price")}
                data-invalid={error.status && !validate("price")}
              />
            </div>
            <div className="check-box-wrapper">
              <input
                className="form-check-input"
                type="radio"
                name="TavaRedio"
                id="tava"
                onClick={() => {
                  setForm({ ...form, tava: !form.tava });
                }}
                checked={form.tava}
              />
              <label className="form-check-label" htmlFor="tava">
                قیمت به صورت توافقی
              </label>
            </div>
            {error.status && !validate("price") && (
              <div className="invalid-feedback"> قیمت اجباری است</div>
            )}
          </div>
        </div>

        <div className="row justify-content-center mt-3">
          <div className="col-12 d-flex justify-content-end">
            <button
              className="btn btn-primary"
              style={{ marginLeft: "5px" }}
              onClick={() => {
                saveChange();
              }}
            >
              {loading.savebtn ? <Spinner size="sm" /> : "ثبت تغییرات"}
            </button>
            <button className="btn btn-primary" onClick={publishHandler}>
              انتشار آگهی
            </button>
          </div>
        </div>
      </>
    );
  };

export default Edit;
